
export default class CovidEntity {
    id=""
    value=""
    date=new Date()
    email=""
    identification=""
    name=""
    company=""
    companyEntity=""

}




// WEBPACK FOOTER //
// ./src/model/CovidEntity.js